// extracted by css-extract-rspack-plugin
export default {"SelectWrapper":"TargetCountriesPicker_SelectWrapper__csTYg"};